import type { Subscription } from "rxjs";
import { Subject } from "rxjs";

export const questionnaireSubject$ = new Subject<RootStoreModule.State>();

export const questionnaireSubscription: { subscription: Subscription | null } = {
  subscription: null,
};
